import { SystemAlert } from './system-alert.table';
import { ISystemAlertMappingItem } from '../contracts/ISystemAlertMappingItem';
import { Params } from '@angular/router';
import { INotificationDto } from '../contracts/INotificationDto';

export class SystemNotificationItem implements ISystemAlertMappingItem {
    
    id: number = 0;
    isRead: boolean = false;
    createDate: Date = null;
    userId: number = 0;
    roleId: number = 0;
    alertId: SystemAlert = SystemAlert.Unknown;
    message: string = null;
    messageParams: string[] = [];
    route: string = null;
    queryParams: Params = null;
    
    // Hace referencia a ThirdPartyId, EvaluationId, etc
    referenceId: number = 0;

    constructor() {
    }

    mapFromNotificationDto(item: INotificationDto): SystemNotificationItem {
        this.id = item.id;
        this.isRead = item.isDone;
        this.message = item.detail;
        this.route = item.url;
        this.createDate = item.createDate;

        return this;
    }
}